import { action } from 'satcheljs';

export const onIsAcceptInviteFlowChanged = action('onIsAcceptInviteFlowChanged', (isAcceptInviteFlow: boolean) => ({ isAcceptInviteFlow }));

export const onUserInvitationCodeChanged = action('onUserInvitationCodeChanged', (invitationCode: string) => ({ invitationCode }));
